import { createSelector} from '@ngrx/store';

import {AppState} from '../app.state';
import {GeneralState} from "./general.reducer";

export const selectGeneralState = (appState: AppState) => appState.generalState;

export const selectIsLoading = createSelector( selectGeneralState, (state: GeneralState) => state.isLoading );
export const selectProfileMeOutput = createSelector( selectGeneralState, (state: GeneralState) => state.profile );
export const selectName= createSelector( selectProfileMeOutput, (profile) => profile?.name );
export const selectAvatar = createSelector(selectProfileMeOutput, (profile) => profile?.avatar?.url );

export const selectClient = createSelector( selectGeneralState, (state: GeneralState) => state.client );
export const selectAwardsRule = createSelector(selectClient, (client) => client?.awards_regulation);
export const selectModules = createSelector(selectGeneralState, (state: GeneralState) => state.modules);
export const selectClientCode = createSelector(selectClient, (client) => client?.code);
export const selectOffices = createSelector(selectClient, (client) => client?.offices);

export const selectMyPoints = createSelector( selectGeneralState, (state: GeneralState) => state.myPoints );

